export default __webpack_public_path__ + "static/media/last-will-icon.f7d9e363.svg";